import { render } from "./DesignSystem.vue?vue&type=template&id=33e05b4d"
import script from "./DesignSystem.vue?vue&type=script&lang=js"
export * from "./DesignSystem.vue?vue&type=script&lang=js"
script.render = render

export default script